angular.module('httpInterceptors', []).factory('http401Interceptor', ["$q", "$window", "$location", "$timeout", function($q, $window, $location, $timeout) {
  return {
    'response': function(response) {
      var ref, ref1, ref2, ref3;
      if (((ref = response.data) != null ? ref.kiosk_mode : void 0) && ((ref1 = response.data) != null ? ref1.redirect_path : void 0)) {
        window.ignoreRollbarErrors = true;
      }
      if (((ref2 = response.data) != null ? ref2.redirect_url : void 0) && ((ref3 = response.config) != null ? ref3.url.indexOf('kiosk') : void 0) >= 0) {
        window.ignoreRollbarErrors = true;
        $window.location = response.data.redirect_url;
      }
      return response;
    },
    responseError: function(response) {
      var ignoredRequest, joinSymbol, message, ref, ref1, ref2, url;
      switch (response.status) {
        case 401:
          if (response.config.url.includes('session_status') && response.data.error === 'Please sign in to continue.') {
            return;
          }
          window.ignoreRollbarErrors = true;
          return $window.location = "/users/sign_in?notice=Your session has expired. Please sign in to continue.";
        case 422:
          window.ignoreRollbarErrors = true;
          message = "Reloading after new sign-in. Please try again.";
          $location.search('notice', message);
          return $timeout(function() {
            return $window.location.reload();
          });
        default:
          url = response.config.url;
          ignoredRequest = url.indexOf('unread_count') >= 0 || url.indexOf('pending_count') >= 0 || url.indexOf('gym_invoices') >= 0 || ((ref = response.config) != null ? (ref1 = ref.params) != null ? ref1.all_contacts_search : void 0 : void 0);
          if (((ref2 = response.data) != null ? ref2.redirect_path : void 0) && !ignoredRequest) {
            window.ignoreRollbarErrors = true;
            url = response.data.redirect_path;
            if (response.data.message) {
              joinSymbol = response.data.redirect_path.indexOf('?') >= 0 ? '&' : '?';
              url = `${url}${joinSymbol}notice=${response.data.message}`;
            }
            return $window.location = url;
          } else {
            return $q.reject(response);
          }
      }
    }
  };
}]).factory('jsonApiInterceptor', function() {
  return {
    response: function(response) {
      var collection, data, item;
      switch (false) {
        case !(_.isArray(response.data.data) && (response.data.meta || _.keys(response.data).length === 1)):
          collection = response.data.data.map(function(item) {
            return angular.extend({
              id: item.id,
              type: item.type
            }, item.attributes);
          });
          if (response.data.meta) {
            collection.meta = response.data.meta;
          }
          response.data = collection;
          break;
        case !(response.data.data && response.data.data.attributes):
          item = response.data.data;
          data = angular.extend({
            id: item.id,
            type: item.type
          }, item.attributes);
          response.data = data;
      }
      return response;
    }
  };
});
